const styleHelper = {
  valueToPX: (value: number): string => `${value}px`,
  pxToValue: (pixels: string): number => parseFloat(pixels.split('px')[0]),
}

export default styleHelper
